interface InsightsToolProps {
  toolName: string;
  args: any;
  result?: string;
  status?: "running" | "complete" | "error";
}

export function InsightsTool({
  toolName: _toolName,
  args,
  result,
  status,
}: InsightsToolProps) {
  // Parse the result if available
  let parsedResult: any = null;
  if (result) {
    try {
      parsedResult = JSON.parse(result);
    } catch (e) {
      console.warn("Failed to parse insights result:", result);
    }
  }

  return (
    <div>
      {/* Show parameters as simple text */}
      {args && Object.keys(args).length > 0 && (
        <div className="space-y-1 text-sm text-gray-500">
          {Object.entries(args).map(([key, value]) => (
            <div key={key}>
              {key.replace(/_/g, " ")}:{" "}
              {typeof value === "string" ? value : JSON.stringify(value)}
            </div>
          ))}
        </div>
      )}

      {/* Show structured results when complete */}
      {parsedResult && status === "complete" && (
        <div className="mt-3">
          {Array.isArray(parsedResult) ? (
            <div className="rounded-lg bg-gray-50 p-3">
              <div className="mb-1 font-medium text-gray-900">
                Teen Insights
              </div>
              <div className="text-sm text-gray-600">
                Found {parsedResult.length} insight
                {parsedResult.length !== 1 ? "s" : ""} processed successfully
              </div>
            </div>
          ) : (
            <div className="text-sm text-gray-600">
              Insights data processed successfully
            </div>
          )}
        </div>
      )}
    </div>
  );
}
